import { render, staticRenderFns } from "./RadialBar.vue?vue&type=template&id=22bcf521&"
import script from "./RadialBar.vue?vue&type=script&lang=js&"
export * from "./RadialBar.vue?vue&type=script&lang=js&"
import style0 from "./RadialBar.vue?vue&type=style&index=0&id=22bcf521&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports